import { render, staticRenderFns } from "./teclado.vue?vue&type=template&id=1817eff7&scoped=true"
import script from "./teclado.vue?vue&type=script&lang=js"
export * from "./teclado.vue?vue&type=script&lang=js"
import style0 from "./teclado.vue?vue&type=style&index=0&id=1817eff7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1817eff7",
  null
  
)

export default component.exports